import { ActionTree } from 'vuex';
import { BbvaDocumentState, BbvaDocument, DocumentRequest } from './types';
import { RootState } from '../types';
import { getBbvaDocument } from '@/api/bbva-document.api';

export const actions: ActionTree<BbvaDocumentState, RootState> = {
    fetchData({ commit }, documentRequest: DocumentRequest) {
        return getBbvaDocument(documentRequest)
        .then((response) => {
            const payload: BbvaDocument = {
                fileType: response.data.data.documentType,
                file: 'data:application/pdf;base64,' + response.data.data.documentContentsBase64, 
            };
            commit('bbvaDocumentLoaded', payload);
        }, (error) => {
            commit('bbvaDocumentError', error);
        });
    }
};


export default actions;